// extracted by mini-css-extract-plugin
module.exports = {"main":"TextCta_main__h0w_o","footer-p":"TextCta_footer-p__66ZGn","body-p":"TextCta_body-p__5h9jd","body-soleil":"TextCta_body-soleil__zTwSk"};